<tool-drawer-container (openFormDialog)="openDialog()">
  <course-grade-estimation-form
    class="form-slot"
  ></course-grade-estimation-form>

  <tool-header
    class="tool-header"
    headerTitle="Course Grade Estimation"
    subtitle="View the grade range or passing probability for a target course"
  ></tool-header>

  <course-grade-estimation-content
    class="main-content"
  ></course-grade-estimation-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Course Grade Estimation'
      )
    "
  ></related-links>
</tool-drawer-container>
